  import {
  IconPhoneCall,
  IconBell,
  IconMessage2,
  IconSquareRoundedX,
  IconPhoneOff,
  IconPhoneEnd,
  IconBriefcase,
  IconDeviceTabletCancel,
  IconFileNeutral,
  IconClockDollar,
  IconHomeStats
} from "@tabler/icons-react";

  export const ALLOWED_LEAD_FIELDS = [
    "fullName",
    "email",
    "phoneNumber",
    "alternateNumber",
    "leadSource",
    "location",
    "product",
    "assigned_to",
    "company",
    "leadStatus",
    "remark",
    "followUpDetails",
    "lastCallDateTime"
  ];

  export const leadFieldOptions = ALLOWED_LEAD_FIELDS.map((field) => ({
    value: field,
    label: field
  }));


  export const ALLOWED_LEAD_STATUS = [
  "CallBack",
  "Ringing",
  "FollowUp",
  "Rejected",
  "NotReachable",
  "SwitchedOff",
  "DealDone",
  "InvalidNumber",
  "Prospect",
  "ECP"
];

export const leadStatusOptions = ALLOWED_LEAD_STATUS.map((status) => ({
  value: status,
  label: status
}));

export const LEAD_STATUS_CONFIG = {
  CallBack: {
    icon: IconPhoneCall,
    bg: "bg-[#E6EFFD]",
    color: "#51A2FF"
  },
  FollowUp: {
    icon: IconMessage2,
    bg: "bg-[#FEEBF5]",
    color: "#F6339A"
  },
  Ringing: {
    icon: IconBell,
    bg: "bg-[#EDF1FE]",
    color: "#6366F0"
  },
  NotReachable: {
    icon: IconPhoneOff,
    bg: "bg-[#F4F2FE]",
    color: "#8A5CF5"
  },
  SwitchedOff: {
    icon: IconPhoneEnd,
    bg: "bg-[#FEF6EC]",
    color: "#F87316"
  },
  InvalidNumber: {
    icon: IconDeviceTabletCancel,
    bg: "bg-[#EEE8E8]",
    color: "#561515"
  },
  Prospect: {
    icon: IconClockDollar,
    bg: "bg-[#ECFDF5]",
    color: "#007A55"
  },
  ECP: {
    icon: IconHomeStats,
    bg: "bg-[#F1F5F9]",
    color: "#45556C"
  },
};

export const DEFAULT_STATUS_CONFIG = {
  icon: IconFileNeutral,
  bg: "bg-gray-100",
  color: "#6A7282"
};
  export const LeadStatusStyles = ({ leadStatus }) =>{
      if (!leadStatus) return <h6>------</h6>;

       const getStatusStyles = (status) => {
        const statusStyles = {
          "CallBack": "min-w-[120px] bg-[#E6EFFD] text-[#0EA4E8] border-[#0EA4E8] font-medium text-center",
          "FollowUp": "min-w-[120px]  bg-[#FEEBF5] text-[#F6339A]  border-[#F6339A] font-medium text-center", 
          "Ringing": "min-w-[120px]  bg-[#EDF1FE] text-[#6366F0]  border-[#6366F0] font-medium text-center",
          "NotReachable": "min-w-[120px]  bg-[#F4F2FE] text-[#8A5CF5]  border-[#8A5CF5] font-medium text-center",
          "SwitchedOff": "min-w-[120px]  bg-[#FEF6EC] text-[#F87316]  border-[#F87316] font-medium text-center",
          "InvalidNumber": "min-w-[118px]  bg-[#EEE8E8] text-[#561515]  border-[#561515] font-medium text-center",
          "Prospect": "min-w-[120px]  bg-[#ECFDF5] text-[#007A55]  border-[#007A55] font-medium text-center",
          "ECP": "min-w-[120px]  bg-[#F1F5F9] text-[#45556C]  border-[#45556C] font-medium text-center",
          "Assigned": "min-w-[120px]  bg-[#FEF9C2] text-[#F0B100]  border-[#F0B100] font-medium text-center",
          "Created": "min-w-[120px]  bg-[#FEF9C2] text-[#F0B100]  border-[#F0B100] font-medium text-center",
          "DealDone": "min-w-[120px]  bg-[#F0FDF4] text-[#00C950]  border-[#00C950] font-medium text-center",
          "Rejected": "min-w-[120px]  bg-[#FEF2F2] text-[#FB2C36]  border-[#FB2C36] font-medium text-center"
        };
    
        return statusStyles[status] || "bg-gray-100 text-gray-800 border border-gray-200";
       };
       return (
          <h6 className={`inline-block px-3 py-1 rounded-full border-2 text-sm font-medium ${getStatusStyles(leadStatus)}`}>
            {leadStatus}
          </h6>
        );
  } 
  export const colorOptions = [
    { value: "--Aqua-400", name: "Aqua-400-(Megaman)" },
    { value: "--Aqua-500", name: "Aqua-500-(Huelveño Horizon)" },
    { value: "--Aqua-600", name: "Aqua-600-(Structural Blue)" },
    { value: "--Aqua-700", name: "Aqua-700-(Mitchell Blue)" },
    { value: "--Aqua-800", name: "Aqua-800-(Commandes)" },
    { value: "--Aqua-900", name: "Aqua-900-(Stegadon Scale Green)" },
    { value: "--Indigo-400", name: "Indigo-400-(Lavender Blue Shadow)" },
    { value: "--Indigo-500", name: "Indigo-500 -(Blue Hepatica)" },
    { value: "--Indigo-600", name: "Indigo-600-(Thick Blue)" },
    { value: "--Indigo-700", name: "Indigo-700-(Megadrive Screen)" },
    { value: "--Indigo-800", name: "Indigo-800-(Evening Magic)" },
    { value: "--Indigo-900", name: "Indigo-900 -(Deep Breath)" },
    { value: "--pink-400", name: "pink-400 -(Pink Katydid)" },
    { value: "--pink-500", name: "pink-500 -(Wild Strawberry)" },
    { value: "--pink-600", name: "pink-600-(Dark Princess Pink)" },
    { value: "--pink-700", name: "pink-700-(Plastic Lips)" },
    { value: "--pink-800", name: "pink-800-(Violettuce)" },
    { value: "--pink-900", name: "pink-900-(Her Fierceness)" },
    { value: "--emerald-400", name: "emerald-400-(Dark Shamrock)" },
    { value: "--emerald-500", name: "emerald-500-(Fennel Fiesta)" },
    { value: "--emerald-600", name: "emerald-600-(Sesame Street Green)" },
    { value: "--emerald-700", name: "emerald-700-(Irish Beauty)" },
    { value: "--emerald-800", name: "emerald-800-(Greens)" },
    { value: "--emerald-900", name: "emerald-900 -(Chrysocolla Dark Green)" },
    { value: "--violet-400", name: "violet-400-(Forgotten Purple)" },
    { value: "--violet-500", name: "violet-500-(Forgotten Kyawthuite)" },
    { value: "--violet-600", name: "violet-600-(Gloomy Purple)" },
    { value: "--violet-700", name: "violet-700-(Swiss Plum)" },
    { value: "--violet-800", name: "violet-800-(Sick Blue)" },
    { value: "--violet-900", name: "violet-900-(Dark Dreams)" },
    { value: "--orange-400", name: "orange-400-(Fall River)" },
    { value: "--orange-500", name: "orange-500-(Liquid Lava)" },
    { value: "--orange-600", name: "orange-600-(Tiger Moth Orange)" },
    { value: "--orange-700", name: "orange-700-(Skrag Brown)" },
    { value: "--orange-800", name: "orange-800-(Gryphonne Sepia Wash)" },
    { value: "--orange-900", name: "orange-900-(Cold Press Coffee)" },
    { value: "--blue-400", name: "blue-400 -(Bleu de France)" },
    { value: "--blue-500", name: "blue-500-(Old Gungeon Red)" },
    { value: "--blue-600", name: "blue-600-(Dead Blue Eyes)" },
    { value: "--blue-700", name: "blue-700 -(Indian Peafowl)" },
    { value: "--blue-800", name: "blue-800-(Cobalt Blue Tarantula)" },
    { value: "--blue-900", name: "blue-900-(Blue Leviathan)" },
    { value: "--yellow-400", name: "chrome yellow-400-(Backlit Lemon)" },
    { value: "--yellow-500", name: "chrome yellow-500-(Vibrant Yellow)" },
    { value: "--yellow-600", name: "chrome yellow-600-(Oh Em Ghee)" },
    { value: "--yellow-700", name: "chrome yellow-700-(Buddha Gold)" },
    { value: "--yellow-800", name: "chrome yellow-800-(Jin Zong Gold)" },
    { value: "--yellow-900", name: "chrome yellow-900-(Brussels Sprout Green)" },
    { value: "--red-400", name: "red-400" },
    { value: "--red-500", name: "red-500" },
    { value: "--red-600", name: "red-600" },
    { value: "--red-700", name: "red-700" },
    { value: "--red-800", name: "red-800" },
    { value: "--red-900", name: "red-900" },
    { value: "--green-400", name: "green-400" },
    { value: "--green-500", name: "green-500" },
    { value: "--green-600", name: "green-600" },
    { value: "--green-700", name: "green-700" },
    { value: "--green-800", name: "green-800" },
    { value: "--green-900", name: "green-900" },
    { value: "--yellow-400", name: "yellow-400" },
    { value: "--yellow-500", name: "yellow-500" },
    { value: "--yellow-600", name: "yellow-600" },
    { value: "--yellow-700", name: "yellow-700" },
    { value: "--yellow-800", name: "yellow-800" },
    { value: "--yellow-900", name: "yellow-900" },
    { value: "--blue-400", name: "blue-400" },
    { value: "--blue-500", name: "blue-500" },
    { value: "--blue-600", name: "blue-600" },
    { value: "--blue-700", name: "blue-700" },
    { value: "--blue-800", name: "blue-800" },
    { value: "--blue-900", name: "blue-900" },
  ];